<template>
	<div class="ReFilterBtn">
		<base-button type="primary" simple icon @click="ShowHideFilter()"><i class="d-inline-block tim-ic ic-filter mt-1 text-primary"></i></base-button>
		<template v-if="bShowOptsCount">
		<el-tag
			v-for="(tag, index) in tags"
			:key="tag + index"
			size="small"
			:type="tagType"
			:closable="true"
			:close-transition="false"
			@close="handleClose(tag)"
		>
		{{ tag }}
		</el-tag>
		</template>
	</div>
</template>

<script>
	import {eventEmitter} from "src/plugins/globalComponents.js";
	import { Tag } from 'element-ui';
	
	export default {
		name: 'ReFilterBtn',
		components: {
			[Tag.name]: Tag
		},
		props: {
			value: Boolean,
			tagType: {
				type: String,
				default: 'primary',
				description: 'Tag type (primary|danger etc)'
			},
			masExcl: Array,
			bShowOptsCount:  {
				type: Boolean,
				default: true,
			}
		},
		data () {
			return {
				ver: 1,
				tags:[],
				objGetParams: {},
				masExcludeParams: ['page','p','c2p'],
			}
		},
		computed: {

		},
		methods: {
			handleClose(tag) {
				this.tags.splice(this.tags.indexOf(tag), 1);
				this.$emit('change', this.tags);
				if (this.tags.length == 0) {
					eventEmitter.$emit('ResetFilter', true);
				}
			},
			setOptCount(data=false){
				//console.log('setOptCount');
				if(!data){
					this.objGetParams = this.$GVO.GetAllGet();
				}else{
					this.objGetParams = data;
				}
				//console.log('setOptCount',this.objGetParams);
				if (!this.$GVO.isEmpty(this.objGetParams)) {
					let masKeys = Object.keys(this.objGetParams);
					let iOptsCount = 0;
					if(typeof this.masExcl != 'undefined'){
						this.masExcludeParams = [...this.masExcludeParams, ...this.masExcl];
					}
					for (let i = 0; i < masKeys.length; i++) {
						if(this.masExcludeParams.indexOf(masKeys[i]) === -1){
							if(this.objGetParams[masKeys[i]] !== false && this.objGetParams[masKeys[i]] !== 'false'){
								iOptsCount++;
							}
						}
					}
					if(iOptsCount>0){
						this.tags = [iOptsCount + this.$GVO.GetSklonCount('options',iOptsCount)];
					}
				} else {
					this.tags = [];
				}
			},
			ShowHideFilter(bHide){
				if(typeof bHide == 'undefined'){
					if(this.value){
						this.$emit('input', false);
					}else{
						this.$emit('input', true);
					}
				}else{
					this.$emit('input', !bHide);
				}
			}
		},
		created(){
			eventEmitter.$on('HideFilter', this.ShowHideFilter);
			eventEmitter.$on('OnFilterApply', this.setOptCount);
			this.setOptCount();
		},
		beforeDestroy() {
			// Отписываемся от события
			eventEmitter.$off('HideFilter', this.ShowHideFilter);
			eventEmitter.$off('OnFilterApply', this.setOptCount);
		},
	}
</script>
<style scoped>
	.ReFilterBtn{
		/*display: flex;
		align-items: center;*/
		position: relative;
	}
	.ReFilterBtn > button{
		margin-top: 0px;
		margin-bottom: 10px;
	}	
	.el-tag{margin: 4px;vertical-align: top;}
</style>
